import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Routes from '../../routes';

export default class Location extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-geo-location-button', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let button = $(event.currentTarget),
        input  = button.closest('.field').find('input[type="text"]'),
        query  = button.closest('.form').find('input[type="text"][name="name"]').val(),
        country = button.closest('.form').find('[name="country_id"]').val();

    event.preventDefault();

    button.addClass('is-loading');

    this.logger('Trying to search city['+ query +']['+ country +'] location');

    return this.App.Geo.Location.search(country +', '+ query, (location) => {
      this.logger('Result:', location);
      input.each(function(){

        let self = $(this),
            name = self.attr('name');

        if (location != null) self.val(location[name]);
        else self.val('');

      });

      button.removeClass('is-loading');
    });

  }
}